import script from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=js"

import "./DualRangeSlider.vue?vue&type=style&index=0&id=0a18e732&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a18e732"]])

export default __exports__